import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import { TitleTypes, ModalTypes, MediaStatusTypes } from '../../Constants';
import Style from './Follow.cssmodule.less';
import { clickButton } from '../../actions/Modal';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';
import Media from '../CommonSet/Media';

class Follow extends BaseComponent {
    constructor(props) {
        super(props);

        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    createRenderView(content) {
        const wrapper = Entry.createElement('div');
        if (content) {
            $('body').append(wrapper);
            wrapper.addClass(Style.editorBlock);
            wrapper.addClass('blocks');
            wrapper.contentEditable = false;
            $(wrapper).attr('block', content);
            const renderView = new Entry.RenderView(wrapper, 'LEFT_MOST');
            renderView.changeCode(new Entry.Code(JSON.parse(content)), true);
            $(wrapper).detach();
        }
        return wrapper;
    }

    createHtmlContent(content) {
        let contentHTML = '';

        if (content) {
            contentHTML = content.replace(/\*\*\*.*?\*\*\*/gim, (item) => {
                let block = item.substring(3, item.lastIndexOf('***'));
                return $('<div>')
                    .append(this.createRenderView(block))
                    .html();
            });
        }

        return contentHTML;
    }

    createContent() {
        let view = null;

        if (this.props.item.content) {
            view = (
                <div
                    className={Style.content}
                    dangerouslySetInnerHTML={{
                        __html: this.createHtmlContent(this.props.item.content),
                    }}
                />
            );
        }

        return view;
    }

    createMediaView() {
        let view = null;
        const { media = {} } = this.props.item;
        const { category } = media;

        if (category && category !== MediaStatusTypes.NONE) {
            view = (
                <Media
                    className={Style.media}
                    media={this.props.item.media}
                    option={{
                        width: 308,
                        height: 190,
                    }}
                />
            );
        }

        return view;
    }

    getContnetViewName() {
        let center = '';

        if (!this.props.item.content) {
            center = ` ${Style.center}`;
        }

        return `${Style.contentView}${center}`;
    }

    getTitleName() {
        let option = '';
        const { titleType, type } = this.props.item;
        if (titleType && titleType !== TitleTypes.DEFAULT) {
            option = `${titleType} ${Style.bigTitleIcon}`;
        } else if (type === ModalTypes.FOLLOW) {
            option = `${TitleTypes.DEFAULT}`;
        } else if (type) {
            option = `${type} ${Style.bigTitleIcon}`;
        }

        return `${Style.title} ${option}`;
    }

    getTitle() {
        let title = '';
        const { titleType, type, title: popupTitle } = this.props.item;
        switch (titleType) {
            case TitleTypes.STOP:
                title = this.Utils.getLang('Menus.wait');
                break;
            case TitleTypes.HINT:
                title = this.Utils.getLang('Menus.hint');
                break;
            case TitleTypes.NOTION:
                title = this.Utils.getLang('Menus.concept_guide');
                break;
            default:
                if (
                    type === ModalTypes.PREBUILT_HINT ||
                    type === ModalTypes.HINT
                ) {
                    title = popupTitle || this.Utils.getLang('Menus.hint');
                } else {
                    title = this.Utils.getLang('Menus.guidance');
                }
                break;
        }

        return title;
    }

    render() {
        return (
            <div className={Style.follow}>
                <Title className={this.getTitleName()} isClose={false}>
                    {this.getTitle()}
                </Title>
                <div className={Style.wrapperView}>
                    <div className={this.getContnetViewName()}>
                        {this.createContent()}
                        {this.createMediaView()}
                    </div>
                    <div className={Style.buttonView}>
                        <Button
                            className={Style.button}
                            text={this.Utils.getLang('Buttons.previous')}
                            onClick={() => this.handleButtonClick('prev')}
                        />
                        <Button
                            className={Style.button}
                            text={this.Utils.getLang('Menus.next')}
                            onClick={() => this.handleButtonClick('next')}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

Follow.displayName = 'Follow';
Follow.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(Follow);



// WEBPACK FOOTER //
// ./components/ModalSet/Follow.js